// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';

const StyledGrid = styled.div`
  display: grid;
  width: 100%;
  align-items: stretch;

> * {
  height: 100%;

  > * {
    height: 100%;
  }
}
`;

const Grid = {
  fields: {
    columns: {
      type: 'select',
      options: [
        { label: '2 columns', value: 2 },
        { label: '3 columns', value: 3 },
        { label: '4 columns', value: 4 },
      ],
    },
    gap: {
      type: 'select',
      options: [
        { label: 'None', value: '0' },
        { label: 'Small', value: '0.5rem' },
        { label: 'Medium', value: '1rem' },
        { label: 'Large', value: '2rem' },
      ],
    },
    responsive: {
      type: 'select',
      options: [
        { label: 'No change', value: 'none' },
        { label: 'Stack on mobile', value: 'stack' },
        { label: 'Half on tablet', value: 'half' },
      ],
    },
    col1: { type: 'slot' },
    col2: { type: 'slot' },
    col3: { type: 'slot' },
    col4: { type: 'slot' },
  },
  defaultProps: {
    columns: 2,
    gap: '1rem',
    responsive: 'stack',
    col1: [],
    col2: [],
    col3: [],
    col4: [],
  },
  render: ({ columns, gap, responsive, col1: Col1, col2: Col2, col3: Col3, col4: Col4 }) => {
    const allCols = [Col1, Col2, Col3, Col4].slice(0, columns);

    const styleId = `grid-${columns}-${responsive}-${gap.replace('.', '')}`;

    return (
      <>
        <style>{`
          .${styleId} {
            gap: ${gap};
            ${responsive === 'stack' ? `
              grid-template-columns: 1fr;
              @media (min-width: 768px) {
                grid-template-columns: repeat(${columns}, 1fr);
              }
            ` : ''}
            ${responsive === 'half' ? `
              grid-template-columns: 1fr;
              @media (min-width: 640px) {
                grid-template-columns: repeat(${Math.min(2, columns)}, 1fr);
              }
              @media (min-width: 1024px) {
                grid-template-columns: repeat(${columns}, 1fr);
              }
            ` : ''}
            ${responsive === 'none' ? `
              grid-template-columns: repeat(${columns}, 1fr);
            ` : ''}
          }
        `}</style>
        <StyledGrid className={ `${styleId}` }>
          {/* eslint-disable-next-line react/no-array-index-key */}
          {allCols.map((Col, i) => <Col key={ i } />)}
        </StyledGrid>
      </>
    );
  }
};

export { Grid };
